/* ============================================================
   Emil Kowalski Design Layer — JS micro-interactions
   ============================================================ */
(function () {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Grid stagger — add .bw-stagger via JS so CSS opacity:0 never flashes */
  function initGridStagger() {
    if (reducedMotion) return;

    const grids = document.querySelectorAll('.grid');
    if (!grids.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const items = Array.from(
            entry.target.querySelectorAll('.grid__item:not(.bw-stagger)')
          );
          items.forEach((item, i) => {
            // Mark as stagger (makes it invisible via CSS)
            item.classList.add('bw-stagger');
            // Reveal with cascading delay
            setTimeout(() => {
              item.classList.add('bw-revealed');
              item.addEventListener(
                'transitionend',
                () => item.classList.remove('bw-stagger', 'bw-revealed'),
                { once: true }
              );
            }, i * 55);
          });
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -30px 0px', threshold: 0.02 }
    );

    grids.forEach((grid) => io.observe(grid));
  }

  /* ── Heading clip reveal ────────────────────────────────── */
  function initHeadingReveal() {
    if (reducedMotion) return;

    const sel = '.section-header h2, h2.title, .section__heading';
    const headings = document.querySelectorAll(sel);
    if (!headings.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('bw-heading-clip');
          // Next frame: add revealed so transition fires
          requestAnimationFrame(() =>
            requestAnimationFrame(() =>
              entry.target.classList.add('bw-revealed')
            )
          );
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.1 }
    );

    headings.forEach((h) => io.observe(h));
  }

  /* ── Magnetic button (subtle cursor pull) ───────────────── */
  function initMagneticButtons() {
    if (reducedMotion) return;

    document
      .querySelectorAll('.button:not([disabled])')
      .forEach((btn) => {
        btn.addEventListener('mousemove', (e) => {
          const r  = btn.getBoundingClientRect();
          const dx = ((e.clientX - r.left - r.width  / 2) / r.width)  * 7;
          const dy = ((e.clientY - r.top  - r.height / 2) / r.height) * 4;
          btn.style.transform = `translate(${dx}px, calc(${dy}px - 3px))`;
        });
        btn.addEventListener('mouseleave', () => {
          btn.style.transform = '';
        });
      });
  }

  /* ── Quantity button pulse ──────────────────────────────── */
  function initQuantityFeedback() {
    if (reducedMotion || !Element.prototype.animate) return;

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.quantity__button');
      if (!btn) return;
      btn.animate(
        [
          { transform: 'scale(0.8)' },
          { transform: 'scale(1.1)', offset: 0.4 },
          { transform: 'scale(1)' },
        ],
        { duration: 300, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' }
      );
    });
  }

  /* ── Cart count badge bounce ────────────────────────────── */
  function initCartBadgeBounce() {
    if (reducedMotion || !Element.prototype.animate) return;

    document.addEventListener('cart:updated', () => {
      const badge =
        document.querySelector('.cart-count-bubble') ||
        document.querySelector('#cart-icon-bubble');
      if (!badge) return;
      badge.animate(
        [
          { transform: 'scale(1)' },
          { transform: 'scale(1.5)', offset: 0.4 },
          { transform: 'scale(1)' },
        ],
        { duration: 380, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' }
      );
    });
  }

  /* ── Init ─────────────────────────────────────────────────  */
  function init() {
    initGridStagger();
    initHeadingReveal();
    initMagneticButtons();
    initQuantityFeedback();
    initCartBadgeBounce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      initGridStagger();
      initHeadingReveal();
      initMagneticButtons();
    });
  }
})();

// Gallery progress fill — syncs with slider-counter--current
(function () {
  function initGalleryProgress() {
    document.querySelectorAll('.bw-gallery-counter').forEach(function (counter) {
      var fill = counter.querySelector('.bw-gallery-fill');
      var track = counter.querySelector('.bw-gallery-track');
      var current = counter.querySelector('.slider-counter--current');
      if (!fill || !track || !current) return;

      var total = parseInt(track.dataset.total, 10) || 1;

      function update() {
        var n = parseInt(current.textContent, 10) || 1;
        var pct = (n / total) * 100;
        fill.style.setProperty('width', pct.toFixed(2) + '%');
      }

      update();
      new MutationObserver(update).observe(current, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryProgress);
  } else {
    initGalleryProgress();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initGalleryProgress);
  }
})();

